/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cerez_S3_R6_PurposeInputs */

const tr_cerez_s3_r6_purpose = /** @type {(inputs: Cerez_S3_R6_PurposeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supabase kimlik doğrulama oturumu (yerel depolama; giriş sırasında kullanılan geçici doğrulama kaydı dahil)`)
};

const en_cerez_s3_r6_purpose = /** @type {(inputs: Cerez_S3_R6_PurposeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supabase authentication session (local storage; including the temporary verification entry used while signing in)`)
};

const de_cerez_s3_r6_purpose = /** @type {(inputs: Cerez_S3_R6_PurposeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supabase-Authentifizierungssitzung (lokaler Speicher; einschließlich des vorübergehenden Prüfeintrags bei der Anmeldung)`)
};

const ru_cerez_s3_r6_purpose = /** @type {(inputs: Cerez_S3_R6_PurposeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сессия аутентификации Supabase (локальное хранилище; включая временную проверочную запись при входе)`)
};

/**
* | output |
* | --- |
* | "Supabase authentication session (local storage; including the temporary verification entry used while signing in)" |
*
* @param {Cerez_S3_R6_PurposeInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const cerez_s3_r6_purpose = /** @type {((inputs?: Cerez_S3_R6_PurposeInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cerez_S3_R6_PurposeInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cerez_s3_r6_purpose(inputs)
	if (locale === "de") return de_cerez_s3_r6_purpose(inputs)
	if (locale === "ru") return ru_cerez_s3_r6_purpose(inputs)
	return tr_cerez_s3_r6_purpose(inputs)
});